// Which operation a failed revision may re-issue, from the cause blobhub-infra records.
//
// Three flows land a failure at draft/failed -- create, commit, and a discard -- so the phase cannot say
// what failed and is only consulted to choose a WORD for the one call DELETE serves both ways.
// docs/specs/2026-09-20-revision-operations.md - "Retry, and why it needed a field in another repository"
export function retryableOperation(revision) {
  if ( "failed" !== revision.status ) {
    return null;
  }
  // No case here for "commit": POST /commit's own gate is {ready}, so re-issuing it against the
  // `failed` status it just left is a 409 every time. Recovery is Reset, then Commit again.
  if ( "delete" === revision.failed_operation ) {
    return "draft" === revision.phase ? "discard" : "delete";
  }
  return null;
}
